<ng-container *ngIf="action$ | async as action">
    <p-button icon="pi pi-trash" [label]="description" ntapDebounceClick (onClick)="executeAction($event)"
       [disabled]="(isDisabled$ | async) ?? true" [ngClass]="{'hide-label-responsive': true}" [pTooltip]="action.tooltip || action.description" ></p-button>
</ng-container>
<p-confirmDialog #cd width="425" appendTo="body" [key]="key">
    <ng-template pTemplate="footer">
        <div class="flex inline-flex" *ngIf="!hideTrajno">
            <span class="mr-2 mb-2 vertical-align-middle">
                <p-checkbox [(ngModel)]="trajnoChecked" [binary]="true" inputId="binary"></p-checkbox><span
                    class="ml-2">Obriši trajno</span>
            </span>
        </div>
        <button type="button" pButton icon="pi pi-times" label="Odustani" (click)="cd.reject()"></button>
        <button type="button" pButton icon="pi pi-check" label="Potvrdi" (click)="cd.accept()"></button>
    </ng-template>
</p-confirmDialog>